import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Badge } from '@repo/ui/badge';
import { Switch } from '@repo/ui/switch';
import { trpc } from '@/providers/trpc';

interface OwnersTableActionsProps {
  owner: {
    disabled: boolean;
    id: string;
  };
}

export function OwnersTableActions({ owner }: OwnersTableActionsProps) {
  useLocale();

  const enableUser = trpc.admin.enableUser.useMutation();
  const disableUser = trpc.admin.disableUser.useMutation();
  const disabled = owner.disabled ?? true;
  const isUpdating = enableUser.isPending || disableUser.isPaused;

  return (
    <div className="flex items-center gap-2">
      <Badge variant={disabled ? 'secondary' : 'default'}>
        {disabled ? t('workspace.inactive') : t('workspace.active')}
      </Badge>
      <Switch
        checked={!disabled}
        disabled={isUpdating}
        onCheckedChange={(checked) => {
          checked
            ? enableUser.mutate({ userId: owner.id })
            : disableUser.mutate({ userId: owner.id });
        }}
      />
    </div>
  );
}
